import { Workshop, WeekDay } from '@/modules/workshops-schedule/models/weekScheduleModels';

export class TicketsManager {
    public getAllWorkshopsInWorkshopTicket(workshop: Workshop, weekDays: WeekDay[]): number[] {
        const workshopsIncludedInTickets: Workshop[] = this.getVisibleWorkshops(weekDays).filter(
            w => workshop.IncludedInTickets.filter((t: number) => w.IncludedInTickets.includes(t)).length > 0,
        );

        if (!workshopsIncludedInTickets.includes(workshop)) {
            // in case of workshop with empty tickets list
            workshopsIncludedInTickets.push(workshop);
        }

        return workshopsIncludedInTickets.filter(x => x.Id).map(x => (x.Id ? x.Id : 0));
    }

    public getAllWorkshopsInTicket(ticketId: number, weekDays: WeekDay[]): number[] {
        const workshopsIncludedInTickets = this.getVisibleWorkshops(weekDays).filter(workshop =>
            workshop.IncludedInTickets.includes(ticketId),
        );

        return workshopsIncludedInTickets.filter(x => x.Id).map(x => (x.Id ? x.Id : 0));
    }

    public getVisibleWorkshops(weekDays: WeekDay[]): Workshop[] {
        const workshops = weekDays
            .map((l: WeekDay) => l.Locations)
            .reduce((a, b) => a.concat(b), [])
            .map(r => r.Rooms)
            .reduce((a, b) => a.concat(b), [])
            .map(r => r.Workshops)
            .reduce((a, b) => a.concat(b), [])
            .filter((w: Workshop) => w.IsVisible);
        return workshops;
    }

    public getAvailableTicketsIds(weekDays: WeekDay[]): number[] {
        return this.getVisibleWorkshops(weekDays)
            .map(x => x.IncludedInTickets)
            .reduce((a, b) => a.concat(b), []);
    }
}
